import type { ChatRepository } from '@src/domain/chat/repository/chat.repository';

/**
 * Connect to Chat Use Case
 * Handles establishing connection to chat service
 */
export class ConnectToChatUseCase {
    constructor(private readonly chatRepository: ChatRepository) { }

    async execute(): Promise<void> {
        await this.chatRepository.connect();
    }
}
